<template>
  <mobile-float-menu header>
    <template v-slot:content>
      <LoadPage :pages='pages' />
    </template>
  </mobile-float-menu>
</template>

<script>
  import LoadPage from "@/components/LoadPage.vue";
  import MobileFloatMenu from "@/components/MobileFloatMenu";

  export default {
    components: {
      LoadPage,
      MobileFloatMenu,
    },
    data() {
      return {
        pages: {
          es: '600f0be01dc45b00179c5e39',
          en: '60061a2cbcd3f20017c8251d',
        }
      }
    },
  }
</script>